import { render } from "./TabBar.vue?vue&type=template&id=42921124&scoped=true&ts=true"
import script from "./TabBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=ts"

import "./TabBar.vue?vue&type=style&index=0&id=42921124&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42921124"],['__file',"src/components/TabBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42921124"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42921124', __exports__)) {
    console.log('reload')
    api.reload('42921124', __exports__)
  }
  
  module.hot.accept("./TabBar.vue?vue&type=template&id=42921124&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('42921124', render)
  })

}


export default __exports__